/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const paragraph = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M11 3.372c-.265-.975-1.354-1.705-2.657-1.705-1.501 0-2.718.97-2.718 2.167 0 1.105 1.038 2.016 2.379 2.15l.213.027M5 12.601c.252.989 1.35 1.733 2.664 1.733 1.501 0 2.718-.97 2.718-2.167 0-1.105-1.037-2.017-2.378-2.15L7.79 9.99m0 0c1.494.154 2.8-.611 2.917-1.71.118-1.098-.997-2.114-2.49-2.268M7.79 9.99C6.297 9.835 5.182 8.82 5.3 7.722c.118-1.099 1.424-1.865 2.917-1.71"
    />
  </svg>
)
export default paragraph
